export default __webpack_public_path__ + "static/media/logo-eo4drr-white.b69c14ee.png";